import { ComponentProps } from "react";
import "./tab-sliding.scss";
import "../button/button.scss";
import { useAppSelector } from "../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../utils/translation";

export interface TabProps<T extends string> extends ComponentProps<"div"> {
  tabChange: (tab: T) => void;
  tab: T;
  tabOptions: {
    [key in T]: string;
  };
}

export function TabSliding<T extends string>({
  tabChange,
  tab,
  tabOptions,
  ...props
}: TabProps<T>) {
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);

  const tabKeys = Object.keys(tabOptions) as Array<T>;

  const renderTabs = () => {
    return tabKeys.map((key) => {
      const isActive = tab === key;
      return (
        <label
          key={key}
          className={`tab ${isActive ? "active" : ""}`}
          htmlFor={`radio-${key}`}
          onClick={() => tabChange(key)}
        >
          {checkTranslationKey(
            translations[lang]?.[tabOptions[key]],
            tabOptions[key]
          )}
        </label>
      );
    });
  };

  const tabCount = tabKeys.length; // Get the number of tabs
  const activeIndex = tabKeys.findIndex((key) => key === tab); // Active tab index

  // Dynamically calculate tab width for multiple tabs
  const tabWidth = 100 / tabCount; // For 2 tabs, this will be 50%

  // Handle edge cases:
  const transformValue = tabCount === 1 ? 0 : activeIndex * 100; // Adjust only for multiple tabs

  return (
    <div {...props} className="tabs-container">
      <div className="tabs">
        {renderTabs()}
        <span
          className={`glider glider-success`}
          style={{
            width: `${tabWidth}%`, // set width as 50% for 2 tabs
            transform: `translateX(${transformValue}%)`, // Move the glider based on the tab count
          }}
        >
          <div className="button-inner-overlay"></div>
        </span>
      </div>
    </div>
  );
}

export default TabSliding;
